import { QueryHandler } from '@/redux/types/query-handler';
import { ApplicationUser } from '@/types/application-user';
import { dispatchOptimisticPatchUpdateUser } from './dispatch-optimistic-patch';
import { UpdateUserQueryArg } from '../types/query-arg';

export const handleResultUpdateUser: QueryHandler<
  UpdateUserQueryArg,
  ApplicationUser
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  // TODO: need to consider updating yourself
  const { patch } = dispatchOptimisticPatchUpdateUser(queryArg, {
    dispatch,
    getState,
  });

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
